



















import { computed, defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import soilApiService from '@/services/soilApiService';
import { Membership } from '@/store/types';

export default defineComponent({
	components: { ConfirmDialog },
	inheritAttrs: false,
	props: {
		membership: {
			type: Object as () => Membership,
			required: true,
		},
	},
	setup(props, { root }) {
		const showConfirmationDialog = ref<boolean>(false);
		const deleteError = ref();
		const isLoading = ref(false);

		const errorMessage = computed<string>(() => {
			if (deleteError.value) {
				if (deleteError.value.response?.status === 409) {
					return 'This user cannot be deleted from this group because they are a member of the parent group.';
				} else {
					return 'An error occurred while attempting to delete the membership. Please try again.';
				}
			} else {
				return '';
			}
		});

		const handleConfirmDelete = async () => {
			try {
				isLoading.value = true;
				await soilApiService.deleteMembership({ groupId: props.membership.groupId, membershipId: props.membership.id });
				showConfirmationDialog.value = false;
			} catch (err) {
				deleteError.value = err;
			} finally {
				isLoading.value = false;
			}
		};

		const handleCleanup = () => {
			deleteError.value = null;
			isLoading.value = false;
			root.$store.dispatch('memberships/getMemberships', props.membership.groupId);
		};

		return {
			showConfirmationDialog,
			handleConfirmDelete,
			isLoading,
			handleCleanup,
			errorMessage,
		};
	},
});
